import moment from 'moment'

export default {
  data () {
    return {
      rawStartDate: null,
      rawEndDate: null,
      periods: [],
      period: null,
      periodConfigDate: {
        wrap: false,
        altFormat: 'J M Y',
        altInput: true
        // dateFormat: 'd/m/Y'
      }
    }
  },
  computed: {},
  methods: {
    resetPeriod () {
      this.period = null
    },
    setCustomPeriod () {
      console.log('setCustomPeriod...')
      this.rawStartDate = this.period.value.startDate.toDate()
      this.rawEndDate = this.period.value.endDate.toDate()
    },
    initPeriods () {
      this.periods.push({
        label: 'Cette semaine',
        value: {
          startDate: moment().startOf('week'),
          endDate: moment().endOf('week')
        }
      })
      this.periods.push({
        label: 'Ce mois ci',
        value: {
          startDate: moment().startOf('month'),
          endDate: moment().endOf('month')
        }
      })
      this.periods.push({
        label: '30 derniers jours',
        value: {
          startDate: moment().subtract(30, 'days'),
          endDate: moment()
        }
      })
      const currentYear = new Date().getFullYear()
      let trimestres = [
        [`1er Trimestre ${currentYear}`, new Date(currentYear, 0, 1), new Date(currentYear, 2, 31)],
        [`2nd Trimestre ${currentYear}`, new Date(currentYear, 3, 1), new Date(currentYear, 5, 30)],
        [`3ème Trimestre ${currentYear}`, new Date(currentYear, 6, 1), new Date(currentYear, 8, 30)],
        [`4ème Trimestre ${currentYear}`, new Date(currentYear, 9, 1), new Date(currentYear, 11, 31)]
      ]
      for (let trimestre of trimestres) {
        let startDate = moment(trimestre[1])
        if (startDate.isBefore(moment())) {
          this.periods.push({
            label: trimestre[0],
            value: {
              startDate,
              endDate: moment(trimestre[2])
            }
          })
        }
      }
      this.periods.push({
        label: 'Cette année',
        value: {
          startDate: moment().startOf('year'),
          endDate: moment().endOf('year')
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/StatsPeriodMixin.js